import { FC } from 'react';

import Stepper from 'components/Stepper';
import { StepOptions } from 'components/Stepper/types';

import { MandateCreationFlowContextProvider } from './hooks/useMandateCreationFlowContext';
import { SelectFromBankAccount } from './steps/SelectFromBankAccount';
import StepMandateCreationSuccess from './steps/StepMandateCreationSuccess';
import StepMandateDocumentUpload from './steps/StepMandateDocumentUpload';
import StepMandateInfoForm from './steps/StepMandateInfoForm';
import StepMandateNothingToDo from './steps/StepMandateNothingToDo';
import StepMandateRecap from './steps/StepMandateRecap';
import StepMandateSchemeChoice from './steps/StepMandateSchemeChoice';

const DirectDebitMandateCreation: FC = () => {
  const steps: StepOptions[] = [
    {
      key: 'mandate-scheme-choice',
      render: (props) => <StepMandateSchemeChoice {...props} />,
    },
    {
      // This step ends the flow
      key: 'nothing-to-do',
      render: (props) => <StepMandateNothingToDo {...props} />,
    },
    {
      key: 'select-from-bank-account',
      render: (props) => <SelectFromBankAccount {...props} />,
    },
    {
      key: 'info-form',
      render: (props) => <StepMandateInfoForm {...props} />,
    },
    {
      key: 'upload-document',
      render: (props) => <StepMandateDocumentUpload {...props} />,
    },
    {
      key: 'recap',
      render: (props) => <StepMandateRecap {...props} />,
    },
    {
      key: 'creation-success',
      render: (props) => <StepMandateCreationSuccess {...props} />,
    },
  ];

  return (
    <MandateCreationFlowContextProvider>
      <Stepper steps={steps} />
    </MandateCreationFlowContextProvider>
  );
};

export default DirectDebitMandateCreation;
